<template>
    <section>
        <b-modal v-model="open" :title="title" ref="modal" id="modal-demo">
            <vue-form-generator ref="createTransmitter2" :schema="schema" :model="model" :options="formOptions" @validated="onValidated"></vue-form-generator>
            <template #footer>
                <b-btn @click="open=false">{{$t('message.cancel')}}</b-btn>
                <b-btn @click="validate" type="primary">{{$t('message.create')}}</b-btn>
            </template>
        </b-modal>
    </section>
</template>

<script>
    import VueFormGenerator from 'vue-form-generator'
    import storage, {TRANSMITTERS_REQUEST} from '../../../_store'
    import mixins from '../../../modules/mixins'
    import eventBus from '../../../modules/eventBus'
    import _ from 'lodash'

    export default {
        name: 'create-transmitter-2',
        mixins: [mixins],
        data () {
            return {
                open: false,
                isValid: false,
                disabled: false,
                item: null,
                control: false,
                title: '',
                model: {
                    entity_id: 0,
                    entity_type: '',
                    control: false,
                    name: '',
                    serialNumber: '',
                    pulse: '1',
                    correction_1: '0',
                    type_1: 'cold',
                    hide_1: false,
                    seal_1: '',
                    label_1: '',
                    correction_2: '0',
                    type_2: 'hot',
                    hide_2: false,
                    seal_2: '',
                    label_2: '',
                    pricePerLiterCold: 'true-0.1',
                    pricePerLiterHot: 'true-0.1',
                    pricePerUnit: 'true-1',
                    koeficient_polohy: '',
                    koeficient_svetove_strany: '',
                    open_1: false,
                    open_2: false,
                    type: 1
                },
                schema: {
                    groups: [{
                        fields: [{
                            type: 'input',
                            inputType: 'text',
                            label: this.$t('message.name'),
                            i18n: {
                                label: 'message.name',
                                placeholder: 'message.transmitter_name_placeholder'
                            },
                            model: 'name',
                            placeholder: this.$t('message.transmitter_name_placeholder'),
                            featured: true,
                            required: true,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: this.$t('message.serial_number'),
                            i18n: {
                                label: 'message.serial_number'
                            },
                            model: 'serialNumber',
                            featured: true,
                            required: true,
                            pattern: /[0-9a-fA-F]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            unitText: () => 'pulsů',
                            i18n: {
                                label: () => this.$t('message.pulse_count_kwh')
                            },
                            visible () {
                                return this.model.type === 2
                            },
                            model: 'pulse',
                            featured: true,
                            required: true,
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            unitText: () => 'l',
                            i18n: {
                                label: () => this.$t('message.pulse_count_l')
                            },
                            visible () {
                                return this.model.type === 1
                            },
                            model: 'pulse',
                            featured: true,
                            required: true,
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }]
                    },
                    {
                        legend: this.$t('message.water_blue'),
                        i18n: {
                            legend: () => this.$t('message.water_blue')
                        },
                        disabled () {
                            return this.model.type !== 1
                        },
                        fields: [{
                            type: 'checkbox',
                            label: this.$t('message.water_blue') + ' ' + this.$t('message.not_used'),
                            i18n: {
                                label: () => this.$t('message.water_blue') + ' ' + this.$t('message.not_used')
                            },
                            model: 'hide_1',
                            isChecked: 'hide_2',
                            validator: [this.isCheckedValidator2]
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            visible: () => !this.model.hide_1,
                            i18n: {
                                label: 'message.correction_water'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.watermeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'select',
                            label: this.$t('message.type'),
                            i18n: {
                                label: 'message.type'
                            },
                            model: 'type_1',
                            required: true,
                            disabled: () => this.model.hide_1,
                            values: [{
                                id: 'hot',
                                name: this.$t('message.hot_water'),
                                i18n: {
                                    name: 'message.hot_water'
                                }
                            }, {
                                id: 'cold',
                                name: this.$t('message.cold_water'),
                                disabled: () => this.model.hide_1,
                                i18n: {
                                    name: 'message.cold_water'
                                }
                            }],
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.price_estimate_water',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            model: 'pricePerLiterCold',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    },
                    {
                        legend: this.$t('message.electricity_meter'),
                        i18n: {
                            legend: () => this.$t('message.electricity_meter')
                        },
                        disabled () {
                            return this.model.type !== 2
                        },
                        fields: [{
                            type: 'inputUnit',
                            inputType: 'text',
                            i18n: {
                                label: 'message.correction_power'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.powermeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            i18n: {
                                label: 'message.price_estimate_power',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            disabled: () => this.model.hide_1,
                            model: 'pricePerLiterCold',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    },
                    {
                        legend: this.$t('message.gas_meter'),
                        i18n: {
                            legend: () => this.$t('message.gas_meter')
                        },
                        disabled () {
                            return this.model.type !== 3
                        },
                        fields: [{
                            type: 'inputUnit',
                            inputType: 'text',
                            i18n: {
                                label: 'message.correction_gas'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_1',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.gasmeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            i18n: {
                                label: 'message.price_estimate_power',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            disabled: () => this.model.hide_1,
                            model: 'pricePerLiterCold',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    },
                    {
                        legend: this.$t('message.heat_meter'),
                        i18n: {
                            legend: () => this.$t('message.heat_meter')
                        },
                        disabled () {
                            return this.model.type !== 4
                        },
                        fields: [{
                            type: 'inputUnit',
                            inputType: 'text',
                            i18n: {
                                label: 'message.correction_heat'
                            },
                            units: () => {
                                return [
                                    { value: 1, label: "" },
                                ]
                            },
                            model: 'correction_1',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            i18n: {
                                label: 'message.koeficient_polohy'
                            },
                            model: 'koeficient_polohy',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            i18n: {
                                label: 'message.koeficient_svetove_strany'
                            },
                            model: 'koeficient_svetove_strany',
                            pattern: /[0-9,.]+/g,
                            validator: VueFormGenerator.validators.string
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.heatmeter_label'
                            },
                            model: 'label_1'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_1'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_1,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_1',
                            visible () {
                                return this.model.open_1
                            }
                        }, {
                            type: 'checkboxText',
                            i18n: {
                                label: 'message.price_estimate_heat',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.heat_units')
                            },
                            disabled: () => this.model.hide_1,
                            model: 'pricePerUnit',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_1
                            }
                        }]
                    },
                    {
                        legend: this.$t('message.water_red'),
                        i18n: {
                            legend: () => this.$t('message.water_red')
                        },
                        disabled () {
                            return this.model.type !== 1
                        },
                        fields: [{
                            type: 'checkbox',
                            label: this.$t('message.water_red') + ' ' + this.$t('message.not_used'),
                            i18n: {
                                label: () => this.$t('message.water_red') + ' ' + this.$t('message.not_used')
                            },
                            model: 'hide_2',
                            isChecked: 'hide_1',
                            validator: [this.isCheckedValidator2]
                        }, {
                            type: 'inputUnit',
                            inputType: 'text',
                            visible: () => !this.model.hide_2,
                            i18n: {
                                label: 'message.correction_power'
                            },
                            units: () => {
                                return [
                                    { value: 1000, label: "m3" },
                                    { value: 1, label: "l" },
                                ]
                            },
                            model: 'correction_2'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_2,
                            i18n: {
                                label: 'message.watermeter_label'
                            },
                            model: 'label_2'
                        }, {
                            type: 'collapseOptions',
                            i18n: {
                                textValue: 'message.advanced_settings'
                            },
                            model: 'open_2'
                        }, {
                            type: 'input',
                            inputType: 'text',
                            label: '',
                            disabled: () => this.model.hide_2,
                            i18n: {
                                label: 'message.seal_number'
                            },
                            model: 'seal_2',
                            visible () {
                                return this.model.open_2
                            }
                        }, {
                            type: 'select',
                            label: this.$t('message.type'),
                            disabled: () => this.model.hide_2,
                            i18n: {
                                label: 'message.type'
                            },
                            model: 'type_2',
                            required: true,
                            values: [{
                                id: 'hot',
                                name: this.$t('message.hot_water'),
                                i18n: {
                                    name: 'message.hot_water'
                                }
                            }, {
                                id: 'cold',
                                name: this.$t('message.cold_water'),
                                i18n: {
                                    name: 'message.cold_water'
                                }
                            }],
                            visible () {
                                return this.model.open_2
                            }
                        }, {
                            type: 'checkboxText',
                            i18n: {
                                label: 'message.price_estimate_water',
                                checkboxLabel: 'message.from_parent_object',
                                unitText: () => this.activeOrganization.currency + ' / ' + this.$t('message.liter')
                            },
                            disabled: () => this.model.hide_2,
                            model: 'pricePerLiterHot',
                            pattern: /^(false|true)-[0-9]+([,.][0-9]+)?$/,
                            validator: [VueFormGenerator.validators.regexp],
                            visible () {
                                return this.model.open_2
                            }
                        }]
                    }]
                },
                formOptions: {
                    validateAfterLoad: false,
                    validateAfterChanged: true
                }
            }
        },
        methods: {
            onValidated  (isValid) {
                this.isValid = isValid
            },
            validate () {
                this.$refs.createTransmitter2.validate()
                if (!this.isValid) {
                    return
                }
                const data = _.cloneDeep(this.model)
                let m = 1
                if (data.type === 4) {
                    data.medium = 'heat'
                    m = 1000
                } else if (data.type === 3) {
                    data.medium = 'gas'
                } else if (data.type === 2) {
                    data.medium = 'power'
                    m = 1000
                } else {
                    data.medium = 'water'
                }
                data.pulse = data.pulse * m
                storage.dispatch(TRANSMITTERS_REQUEST, data)
                    .then(response => {
                        const data = response.data
                        if (data.result) {
                            this.open = false
                            eventBus.emit('change', {force: true, source: 'create-transmitter-2'})
                            this.notify('info', data.message)
                        } else {
                            this.notify({
                                content: data.message,
                                duration: 5000
                            })
                        }
                    })
                    .catch(err => {
                        this.notify('danger', this.getErrorMessage(err))
                    })
            },
            show (item, control, type) {
                this.resetModel()
                this.model.type = type
                this.open = true
                this.item = item
                this.control = control

                const info = '(' + this.objectText(item.type) + ' - ' + item.name + ')'
                if (control) {
                    this.title = this.$t('message.add_validation_transmitter') + ' ' + info
                } else {
                    this.title = this.$t('message.add_transmitter') + ' ' + info
                }

                this.model.control = control
                this.model.entity_id = item.id
                this.model.entity_type = item.type
            },
            objectText (type) {
                switch (type) {
                case 'organization':
                    return this.$t('message.organization')
                case 'building':
                    return this.$t('message.building')
                case 'unit':
                    return this.$t('message.unit')
                case 'transmitter':
                    return this.$t('message.transmitter')
                }
            },
            resetModel () {

                this.model = {
                    entity_id: 0,
                    entity_type: '',
                    control: false,
                    name: '',
                    serialNumber: '',
                    pulse: '1',
                    correction_1: '0',
                    type_1: 'cold',
                    hide_1: false,
                    seal_1: '',
                    label_1: '',
                    correction_2: '0',
                    type_2: 'hot',
                    hide_2: false,
                    seal_2: '',
                    label_2: '',
                    pricePerLiterCold: 'true-0.1',
                    pricePerLiterHot: 'true-0.1',
                    pricePerUnit: 'true-1',
                    koeficient_polohy: '',
                    koeficient_svetove_strany: '',
                    open_1: false,
                    open_2: false,
                    type: 1
                }
            }
        },
        created () {
        }
    }
</script>

<style scoped>

</style>
